import getIn from 'transmute/getIn';
export const getIndexedAsyncConnectedAccounts = getIn(['threadViewRootReducer', 'connectedAccounts']);